import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://238981aa6f5a9d87e8fafdbb225bbd6f@o4510121835692032.ingest.us.sentry.io/4512112771334144',
  environment: import.meta.env.MODE,
  release: 'sales-tax-kit@1.0.6',
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: false,
    httpBodies: [],
    urlQueryParams: false,
  },
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
})
